<template>
  <focus-lock>
    <el-dialog
      ref="closedAccountDialog"
      v-loading.fullscreen.lock="mainLoader"
      :show-close="false"
      :visible.sync="dialogVisible"
      custom-class="closed-account-dialog"
      element-loading-background="rgba(255, 255, 255, 0.8)"
      title="Are you sure? We’ll store your data for 30 days, during which time you can change your mind. After 30 days we‘ll permanently delete your data and we won’t be able to recover it for you."
      @opened="dialogOpen('closedAccountDialog')"
      @close="onClose($event)"
    >
      <div class="body">
        <svg-danger-exclamation />
        <h1>Choose new organisation owner</h1>
        <p>Please nominate a new owner of the organisation {{ organisation.name }}.</p>
        <h2 class="w-100">
          Members
        </h2>
        <OrganisationMemberCard
          v-for="(member,index) in members" 
          :key="index" 
          :member="member"
          @mark-as-owner="onNewdOwnerNominated"
        />

        <div class="button-wrap d-flex">
          <el-button
            @click="onClose($event)"
          >
            Go, back
          </el-button>
          <el-button
            type="primary"
            :loading="mainLoader"
            :disabled="!newNomintedMember"
            @click.prevent="$emit('selected-new-owner', newNomintedMember)"
          >
            Nominate new owner
          </el-button>
        </div>
      </div>
    </el-dialog>
  </focus-lock>
</template>

<script>
import svgDangerExclamation from '@/components/assets/svg-danger-exclamation'
import OrganisationMemberCard from '@/components/partials/organisation-member-card'
export default {

  components: {
    svgDangerExclamation,
    OrganisationMemberCard
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    organisation:{
      type: Object,
      default: null
    },
    members:{
      type: Array,
      default: () => [],
    }
  },

  data() {
    return {
      mainLoader: false,
      dialogVisible: false,
      newNomintedMember: null,
      closingTheAccount: false
    }
  },

  watch: {
    visible() {
      this.dialogVisible = this.visible
    }
  },

  created() {
    this.dialogVisible = this.visible
  },

  methods : {
    onClose() {
      this.dialogVisible = false
      this.$emit('closed')
    },
    onNewdOwnerNominated(member){
      let memberFound = this.members.find(m => m.is_nominated)
      if(memberFound)
      {
        this.$set(memberFound, 'is_nominated', false)
      }
      this.$set(member, 'is_nominated', true)
      this.newNomintedMember = member
    }
  }
}
</script>
